/*
 * @Author: 小周
 * @Date: 2023-10-17 10:22:11
 * @LastEditTime: 2024-07-26 10:10:11
 * @LastEditors: MrZHLF
 * @Description:
 */

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getDetail } from '@/api/index'
import { getTimer } from '@/utils/timer'
import styles from './index.module.scss'
import { Button } from 'react-vant'
import OpenLaunchApp from '../../components/openLaunchApp'

import { openAppArticleId } from '@/utils/openApp'

const DetailPage = () => {
  const { id } = useParams()
  const [detail, setDetail] = useState({})
  useEffect(() => {
    getDetail(id).then((res) => {
      console.log(res, '1')
      if (res.code == 0) {
        setDetail(res.result)
      }
    })
  }, [id])

  const handleOpenApp = () => {
    openAppArticleId(detail.articleId, 5)
  }

  return (
    <>
      <div>{detail.articleTitle}</div>
      <div
        dangerouslySetInnerHTML={{ __html: detail.contentBody }}
        className={styles.content}
      ></div>
      <p>当前时间: {getTimer(detail.publishDate)}</p>
      <div className={styles.btn_wrap}>
        <Button type="primary" onClick={handleOpenApp}>
          修改名字
        </Button>
        <OpenLaunchApp
          isArticle={true}
          articleId={detail.articleId}
          msgType={5}
        />
      </div>
      <p className={styles.text}>谁对时间越吝啬，时间就对谁越慷慨。</p>
      <p className={styles.text1}>这就是倒影的文字啊</p>
      <p className={styles.text2}>填充</p>
      <div className={styles.demo}></div>
      <div className={styles.star}></div>
      <div className={styles.star1}></div>
      <div className={styles.star2}></div>
    </>
  )
}

export default DetailPage
